import React from 'react';
import { FieldErrors } from './FieldErrors';
export const TextInput = (props) => {
    const onChange = (event) => {
        props.onChange(event.currentTarget.value);
    };
    return (React.createElement("div", { className: "input-set" },
        React.createElement("label", { htmlFor: props.id },
            props.label,
            props.required ? ' *' : ''),
        React.createElement("input", { type: "text", id: props.id, "data-testid": props.id, value: props.value || '', onChange: onChange, autoComplete: props.autocomplete }),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name || props.id })));
};
